/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personalnummer1Inputs */

const de__field_personalnummer1 = /** @type {(inputs: _Field_Personalnummer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalnummer`)
};

/**

* @param {_Field_Personalnummer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personalnummer1 = /** @type {((inputs?: _Field_Personalnummer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personalnummer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personalnummer1(inputs)
});
export { _field_personalnummer1 as "_field_personalNummer" }